import styles from "./style.module.scss";

const TrainingListLoader = () => {
  return [...new Array(10)].map((index) => {
    return (
      <div
        key={index}
        className={styles.skeleton}
        style={{
          height: "30px",
          borderRadius: "8px",
          width: "100%",
          margin: "20px 0",
        }}
      ></div>
    );
  });
};

export default TrainingListLoader;
